import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as actions from 'global/actions/signUpActions';
import CurvedContainer from '../../components/CurvedContainer';
import { colors } from 'global/colors';
import { Wrapper, Container, Input, Header, Button, InfoText, Form, Checkbox } from '../../components';
import { Link, BottomContainer, SignupDescription } from './styles';
import { useActions } from 'hooks/useActions';
import { Images } from 'util/images';
import { useAppContext } from 'hooks/useContext';
import * as strings from './strings';
import { getCookie } from 'functions/getCookie';
import Path from 'routes/Path';
import apiErrors from 'api/apiErrors';

export default React.memo(() => {
  const { loading, error, success } = useSelector((state) => state.signUp);
  const { clearError, clearState, signup } = useActions(actions);

  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [name, setName] = useState('');
  const [isCompany, setIsCompany] = useState(false);
  const [isAgreementAgreed, setIsAgreementAgreed] = useState(false);
  const [isGDPRAgreed, setIsGDPRAgreed] = useState(false);
  const [campaignSource, setCampaignSource] = useState('');

  const { language } = useAppContext();

  useEffect(() => {
    if (getCookie('campaignSource')) setCampaignSource(getCookie('campaignSource'));
  }, []);

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  return (
    <Wrapper>
      <CurvedContainer bottom image={Images.bluff} height={110} />
      <Container color={colors.lightGray} half column>
        <Header>{strings.header[language]}</Header>
        <Form
          onChange={() => error && clearError()}
          onSubmit={() => {
            signup(
              email,
              company,
              name,
              isCompany,
              isAgreementAgreed,
              isGDPRAgreed,
              campaignSource ? campaignSource : undefined
            );
          }}
        >
          <Input
            autoFocus
            type="email"
            name="email"
            autoComplete="email"
            value={email}
            placeholder={strings.emailPlaceholder[language]}
            onChange={(e) => setEmail(e.target.value)}
            disabled={success}
          />
          {isCompany ? (
            <Input
              type="text"
              value={name}
              placeholder={strings.namePlaceholder[language]}
              onChange={(e) => setName(e.target.value)}
              disabled={success}
            />
          ) : null}
          {isCompany ? (
            <Input
              type="text"
              value={company}
              placeholder={strings.companyPlaceholder[language]}
              onChange={(e) => setCompany(e.target.value)}
              disabled={success}
            />
          ) : null}
          <Checkbox
            right
            checked={isCompany}
            label={strings.companyLabel[language]}
            onChange={(e) => setIsCompany(e.target.checked)}
          />
          {isCompany ? null : (
            <Checkbox
              right
              checked={isAgreementAgreed}
              label={strings.agreementLabel[language]}
              onChange={(e) => setIsAgreementAgreed(e.target.checked)}
            />
          )}
          {isCompany ? null : (
            <Checkbox
              right
              checked={isGDPRAgreed}
              label={strings.GDPRLabel[language]}
              onChange={(e) => setIsGDPRAgreed(e.target.checked)}
            />
          )}
          <Button
            primary
            type="submit"
            disabled={
              !email ||
              (isCompany && !name) ||
              (isCompany && !company) ||
              (!isCompany && !isAgreementAgreed) ||
              (!isCompany && !isGDPRAgreed) ||
              error ||
              success
            }
          >
            {strings.header[language]}
          </Button>
        </Form>
        <BottomContainer>
          <InfoText error={error} success={success}>
            {loading ? strings.loadingLabel[language] : ''}
            {apiErrors?.[error?.name]?.[language] ?? error}
            {success ? strings.successLabel[language] : ''}
          </InfoText>
          <Link to={Path.loginPage}>{strings.loginLabel[language]}</Link>
          <SignupDescription>{strings.companyDescription[language]}</SignupDescription>
        </BottomContainer>
      </Container>
    </Wrapper>
  );
});
